module.exports = __webpack_public_path__ + "h5/img/file.9d0488ad.png";